import { CookieService } from 'ngx-cookie-service';
import { Injectable } from '@angular/core';
import { Md5 } from 'ts-md5';
import Pusher, { PresenceChannel } from 'pusher-js';

import { environment } from '@env/environment';
import { FormService } from '@state/form';
import { PusherFacade } from '@state/pusher/pusher.facade';

export enum PusherStatus {
  MemberAdded = 'pusher:member_added',
  MemberRemoved = 'pusher:member_removed',
  SubscriptionSucceeded = 'pusher:subscription_succeeded'
}

interface PresenceChannels {
  [id: string]: PresenceChannel;
}

interface PresenceCallbacks {
  success?: (data: any) => void;
  added?: (data: any) => void;
  removed?: (data: any) => void;
}

@Injectable({
  providedIn: 'root'
})
export class PusherPresenceService {
  presenceChannels: PresenceChannels = {};
  pusher: Pusher;

  constructor(private cookieService: CookieService, public formService: FormService) {
    let token = this.cookieService.get('token');
    let headers = { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
    let options = {
      auth: {
        headers,
        params: {}
      },
      authEndpoint: `${environment.apiUrl}/user/presence_channel`,
      cluster: environment.PUSHER_CLUSTER,
      encrypted: true
    };
    this.pusher = PusherFacade.create(environment.PUSHER_KEY, options);
  }

  channelId(channelString: string): string {
    return `presence-${Md5.hashStr(channelString)}`;
  }

  createPresenceChannel(channelString: string, { success, added, removed }: PresenceCallbacks): void {
    let channelId = this.channelId(channelString);
    this.presenceChannels[channelId] = this.pusher.subscribe(channelId) as PresenceChannel;

    if (success) this.presenceChannels[channelId].bind(PusherStatus.SubscriptionSucceeded, success);
    if (added) this.presenceChannels[channelId].bind(PusherStatus.MemberAdded, added);
    if (removed) this.presenceChannels[channelId].bind(PusherStatus.MemberRemoved, removed);
  }

  destroyPresenceChannel(channelString: string): void {
    let channelId = this.channelId(channelString);
    this.presenceChannels[channelId].unbind();
    this.presenceChannels[channelId].unsubscribe();
  }
}
